import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, filter, map, Observable, of, retry, switchMap, throwError } from 'rxjs';
import { User } from '../model/user';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Admin } from './admin';

const USER_KEY = "user";
@Injectable({
  providedIn: 'root'
})
export class Auth {
  private userSubject: BehaviorSubject<User | null>;
  // public imgData:BehaviorSubject<any> = new BehaviorSubject<any>(false);
  imgData$ = new BehaviorSubject<string | null>(localStorage.getItem('profilePic'));
  public user:Observable<User |null>;
  // public profilePic$: Observable<any |null> = of({});
  constructor(
    private router:Router,
    private http: HttpClient,
    private adminService:Admin
  ) {
    this.userSubject = new BehaviorSubject(JSON.parse(localStorage.getItem(USER_KEY)!));
    this.user = this.userSubject.asObservable();
   
   }

   public get userValue(){
    
    return  this.userSubject.value;
   }

   login(cred:any,saveCred:boolean){
    return this.http.post<User>(`${environment.apiUrl}/auth/login`,cred)
     .pipe(map(user =>{
      console.log(user);
        this.userSubject.next(user);
        if(this.user!=null && (user?.photoPath || user.photoPath !="string" || user.photoPath !=undefined)){
          console.log(user)
          this.getProfile(user.photoPath);
        }
        localStorage.setItem(USER_KEY,JSON.stringify(user));
        
     }))
   }


  getProfile(photoPath: any) {
    if (!photoPath || photoPath === "" || photoPath === "string") {
      this.imgData$.next(null);
      localStorage.removeItem('profilePic');
      return;
    }
    this.adminService.getMediaById(photoPath).subscribe({
      next: (data: any) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const dataUrl = e.target.result as string;
          this.imgData$.next(dataUrl);
          try { localStorage.setItem('profilePic', dataUrl); } catch (e) { console.warn('localStorage full or blocked', e); }
        };
        reader.readAsDataURL(new Blob([data]));
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }
  

   getPin(passRequest: any) {
    return this.http.post<User>(`${environment.apiUrl}/auth/pin`, passRequest)
        .pipe(map(data => {
        
            return data;
        }));
}
forgotPassword(passRequest: any) {
  return this.http.post<User>(`${environment.apiUrl}/auth/forgotPassword`, passRequest)
      .pipe(map(data => {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
//console.log("User "+JSON.stringify(data))
          return data;
      }));
}
   logout(){
    localStorage.removeItem(USER_KEY);
    this.userSubject.next(null);
    // localStorage.clear();
    const allStorageKeys = Object.keys(localStorage);
    allStorageKeys.forEach((currentKey) => {
    if (currentKey !== 'cookiePreferences') {
      localStorage.removeItem(currentKey);
    }
  });
    // this.router.navigate(['login']);
    this.router.navigate(['/']);
   }

   updateProfile(user:any){
    return this.http.patch<any>(`${environment.apiUrl}/auth/user`,user)
    .pipe(map(data => {
      return data;
    }));
   }


   verifyUser(userId:any){
    return this.http.get<any>(`${environment.apiUrl}/auth/verify/${userId}`)
    .pipe(map(data => {
      return data;
    }));
   }
  

   accountActivation(customerId:any):Observable<any>{
    return this.http.get<any>(environment.apiUrl + "/auth/accountActivation?userId=" + customerId)
    .pipe(
        catchError(this.errorHandle)
    );
   }

  
   getAppUser(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + `/auth/user`)
      .pipe(
        catchError(this.errorHandle)
      );
  } 

  updateAppUser(user:any){
    localStorage.setItem("user", JSON.stringify(user));
    this.getProfile(user.photoPath);
    this.userSubject.next(user);
  }


   parseJwt(token:any){
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
   }

   errorHandle(error:any){
    let errorMessage='';
    if(error.error.error instanceof ErrorEvent){
      errorMessage = error.error.error;
    }else{

    }
    console.log(errorMessage);
    return throwError(()=>{
      return errorMessage;
   })
   }
}
